define(function () {
    const app = require('Cloud/Application/app');
    const _ = require('Cloud/Application/_');
    const { isFolder } = require('reactApp/modules/file/utils');
    const config = require('Cloud/config');

    return function () {
        const IS_PHONE = app.getParam('PHONE_BROWSER');
        const IS_MOBILE = app.getParam('MOBILE_BROWSER');
        const IS_ONPREMISE = app.getParam('ON_PREMISE');
        const IS_REACT_PAGE = app.getParam('REACT_PAGE');
        const MAIL_HOST = IS_PHONE || IS_MOBILE ? 'touch.mail.ru' : config.get('MAIL_HOST');
        const BUILD_URLS = config.get('BUILD_URLS');
        const IS_PUBLIC_ALBUM = config.get('IS_PUBLIC_ALBUM');

        const sendItem = {
            id: 'email',
            name: 'Отправить',
            url(data) {
                return `https://${MAIL_HOST}/compose/?Subject=${encodeURIComponent(data.title)}&Body=${encodeURIComponent(data.url)}`;
            },
            fullsize: true,
        };

        const socials = IS_ONPREMISE
            ? [
                  sendItem,
              ]
            : [
                  sendItem,
                  {
                      id: 'vk',
                      name: 'ВКонтакте',
                      url(data) {
                          return `${`https://vk.com/share.php?url=`}${encodeURIComponent(data.url)}`;
                      },
                  },
                  {
                      id: 'ok',
                      name: 'Одноклассники',
                      url(data) {
                          return `${`https://connect.ok.ru/offer?url=`}${encodeURIComponent(data.url)}`;
                      },
                  },
                  {
                      id: 'tw',
                      name: 'Twitter',
                      url(data) {
                          return `${`https://twitter.com/share?&url=`}${encodeURIComponent(data.url)}&counturl=${encodeURIComponent(data.url)}`;
                      },
                  },
                  {
                      id: 'mm',
                      name: 'Мой Мир',
                      url(data) {
                          return `${`https://connect.mail.ru/share?url=`}${encodeURIComponent(data.url)}`;
                      },
                  },
              ];

        function popup(id, action, item) {
            const data = {
                url: item ? app.publicUrl(item, IS_PUBLIC_ALBUM) : 'https://cloud.mail.ru/promo/',

                image: item && item.thumbnails ? item.thumbnails['320x240'] : `${BUILD_URLS.staticPath}img/share.jpg`,

                title: item ? `${isFolder(item) ? 'Папка' : 'Файл'} из Облака Mail.ru` : '25Гб бесплатно в Облаке!',

                descr: `Облако Mail.ru - это ваше персональное надежное хранилище в интернете. Все нужные файлы всегда под рукой, доступны в любой точке мира с компьютера или смартфона.`,
            };

            if (id !== 'email') {
                data.url += `?utm_source=${id}&utm_medium=post&utm_campaign=${action}`;
            }

            let social;

            socials.forEach(function (item) {
                if (item.id === id) {
                    social = item;
                }
            });

            if (social) {
                if (social.fullsize) {
                    _.openTab(social.url(data));
                } else {
                    _.openPopup(social.url(data));
                }

                RADAR(`app_social_${action}-${id}_${IS_REACT_PAGE ? 'react' : _.sid()}`);
            } else {
                RADAR.error(`social-${id}`);
            }
        }

        Object.assign(app, {
            social: {
                list: socials,

                publishItem(id, item) {
                    popup(id, 'publish-file', item);
                },
            },
        });
    };
});
